module.exports = __webpack_public_path__ + "static/media/main_105.516e9bf7.ico";